var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { AutoComplete } from 'antd';
import { useMemberLocationsLazyQuery } from 'apollo/queries/MEMBER_LOCATIONS';
var composeAddressLine = function (address) {
    if (!address || !address.address_1)
        return false;
    var address_1 = address.address_1, city = address.city, state = address.state, zip = address.zip;
    return "".concat(address_1, ", ").concat(city, ", ").concat(state, " ").concat(zip);
};
var LocationsAutocomplete = function (_a) {
    var memberId = _a.memberId, defaultValue = _a.defaultValue, onSelect = _a.onSelect, onSearch = _a.onSearch;
    var _b = useState([]), locationOptions = _b[0], setLocationOptions = _b[1];
    var loadMemberLocations = useMemberLocationsLazyQuery({
        onCompleted: function (data) {
            if (!data || !data.member)
                return false;
            var composedAddress = composeAddressLine(data.member.address_details);
            var options = __spreadArray(__spreadArray([], (composedAddress
                ? [
                    {
                        value: composeAddressLine(data.member.address_details)
                    }
                ]
                : []), true), data.member.locations.map(function (i) { return ({ value: i.address }); }), true);
            setLocationOptions(options.length > 0
                ? [
                    {
                        label: 'Member Addresses',
                        options: options
                    }
                ]
                : []);
        }
    })[0];
    useEffect(function () {
        if (memberId)
            loadMemberLocations({
                variables: {
                    id: memberId
                }
            });
        else
            setLocationOptions([]);
    }, [memberId]);
    return (_jsx(AutoComplete, { options: locationOptions, style: { minWidth: '20%' }, onSelect: onSelect, showSearch: { onSearch: onSearch }, defaultValue: defaultValue, placeholder: "Location", allowClear: true, "data-test": "locationsAutocomplete" }));
};
export default LocationsAutocomplete;
